import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { InlineMessage, INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import UserTimeFormat from '../../../components/user-time-format/connected';

import { WAREHOUSE_SETTINGS_URL } from '../../../pages/settings/ship-from-locations/constants';
import { formatTimeFrom24Hour } from '../../../services/time-helper-service';
import messages from './messages';

import style from './style.module.less';

/**
 * @typedef {object} SelectedContact
 * @property {string} [firstName]
 * @property {string} [lastName]
 * @property {string} [phoneNumber]
 * @property {string} [emailAddress]
 */

/**
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} props.shipFromName
 * @param {SelectedContact} [props.selectedContact]
 * @param {boolean} props.hasSellerSelectedPickupDays
 * @param {string} [props.startTime]
 * @param {string} [props.endTime]
 * @param {string} [props.shipFromId]
 * @param {string} [props.instructions]
 * @returns {JSX.Element}
 */
const PickupInformation = ({
  className,
  shipFromName,
  selectedContact,
  hasSellerSelectedPickupDays,
  startTime,
  endTime,
  shipFromId,
  instructions,
}) => {
  return (
    <div className={classnames(style['section-wrapper'], className)}>
      <div className={style.section}>
        <div className={style.title}>
          <FormattedMessage {...messages.pickupContact} />
        </div>
        <div>{shipFromName}</div>
        {selectedContact && (
          <>
            <div>{`${selectedContact?.firstName} ${selectedContact?.lastName}`}</div>
            <div>{selectedContact?.phoneNumber}</div>
            <div>{selectedContact?.emailAddress}</div>
          </>
        )}
        {!selectedContact && <FormattedMessage {...messages.noContactSelected} />}
      </div>
      <div className={style.section}>
        <div className={style.title}>
          <FormattedMessage {...messages.pickupWindow} />
        </div>
        {hasSellerSelectedPickupDays && (
          <FormattedMessage
            {...messages.pickupWindowTime}
            values={{
              startTime: <UserTimeFormat value={formatTimeFrom24Hour(startTime)} />,
              endTime: <UserTimeFormat value={formatTimeFrom24Hour(endTime)} />,
            }}
          />
        )}
        {!hasSellerSelectedPickupDays && '--'}
      </div>
      {!hasSellerSelectedPickupDays && (
        <div className={style.section}>
          <InlineMessage type={INLINE_MESSAGE_TYPES.error}>
            <FormattedMessage
              {...messages.localDeliveryPickupError}
              values={{
                a: (chunks) => (
                  <Link
                    className={style['contact-error-link']}
                    to={{
                      pathname: `${WAREHOUSE_SETTINGS_URL}/${shipFromId}/pickup-settings`,
                      state: WAREHOUSE_SETTINGS_URL,
                    }}
                  >
                    {chunks}
                  </Link>
                ),
              }}
            />
          </InlineMessage>
        </div>
      )}
      <div className={style.section}>
        <div className={style.title}>
          <FormattedMessage {...messages.pickupInstruction} />
        </div>
        {instructions || '--'}
      </div>
    </div>
  );
};

export default PickupInformation;
